var React = require('react');

function LuxeUncheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 1L1 11","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1L11 11","stroke":"black","strokeWidth":"1.5","strokeLinejoin":"round","key":1})]);
}

LuxeUncheck.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = LuxeUncheck;

LuxeUncheck.default = LuxeUncheck;
